// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/Images/VITAL CLIC IMAGEN2.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Contenedor principal */
.PatientForm_formContainer__ep1VC {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); /* Cambia por la ruta de tu imagen de fondo */
    background-size: cover;
    background-position: center;
    padding: 20px;
  }
  
  /* Título */
  .PatientForm_title__3Ulvq {
    font-size: 2.5rem;
    color: #ffffff;
    margin-bottom: 20px;
  }
  
  /* Formulario */
  .PatientForm_form__abZxr {
    width: 100%;
    max-width: 500px;
    display: flex;
    flex-direction: column;
  }
  
  /* Etiquetas */
  .PatientForm_label__2kGRN {
    font-size: 1rem;
    color: #ffffff;
    margin-top: 10px;
    margin-bottom: 5px;
  }
  
  /* Inputs */
  .PatientForm_input__n16AZ {
    padding: 10px;
    font-size: 1rem;
    border: 1px solid #ffffff;
    border-radius: 5px;
    background-color: rgba(255, 255, 255, 0.8);
    margin-bottom: 10px;
    outline: none;

  }
  
  /* Botón */
  .PatientForm_button__yGkV- {
    margin-top: 20px;
    padding: 10px;
    font-size: 1.2rem;
    color: #4a5b57;
    background-color: #ffffff;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-weight: bold;
  transition: background-color 0.5s ease;

  }
  
  .PatientForm_button__yGkV-:hover {
    background-color: #4a5b57;
    color: white;
  }
  

  @media screen and (max-width:768px) {
    .PatientForm_title__3Ulvq {
      font-size: 1.5rem;
     
    }
  }`, "",{"version":3,"sources":["webpack://./src/styles/Home/PatientForm.module.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,yDAAqE,EAAE,6CAA6C;IACpH,sBAAsB;IACtB,2BAA2B;IAC3B,aAAa;EACf;;EAEA,WAAW;EACX;IACE,iBAAiB;IACjB,cAAc;IACd,mBAAmB;EACrB;;EAEA,eAAe;EACf;IACE,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,sBAAsB;EACxB;;EAEA,cAAc;EACd;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA,WAAW;EACX;IACE,aAAa;IACb,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,0CAA0C;IAC1C,mBAAmB;IACnB,aAAa;;EAEf;;EAEA,UAAU;EACV;IACE,gBAAgB;IAChB,aAAa;IACb,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB;EACnB,sCAAsC;;EAEtC;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;;EAGA;IACE;MACE,iBAAiB;;IAEnB;EACF","sourcesContent":["/* Contenedor principal */\n.formContainer {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    background-image: url('../../assets/Images/VITAL\\ CLIC\\ IMAGEN2.png'); /* Cambia por la ruta de tu imagen de fondo */\n    background-size: cover;\n    background-position: center;\n    padding: 20px;\n  }\n  \n  /* Título */\n  .title {\n    font-size: 2.5rem;\n    color: #ffffff;\n    margin-bottom: 20px;\n  }\n  \n  /* Formulario */\n  .form {\n    width: 100%;\n    max-width: 500px;\n    display: flex;\n    flex-direction: column;\n  }\n  \n  /* Etiquetas */\n  .label {\n    font-size: 1rem;\n    color: #ffffff;\n    margin-top: 10px;\n    margin-bottom: 5px;\n  }\n  \n  /* Inputs */\n  .input {\n    padding: 10px;\n    font-size: 1rem;\n    border: 1px solid #ffffff;\n    border-radius: 5px;\n    background-color: rgba(255, 255, 255, 0.8);\n    margin-bottom: 10px;\n    outline: none;\n\n  }\n  \n  /* Botón */\n  .button {\n    margin-top: 20px;\n    padding: 10px;\n    font-size: 1.2rem;\n    color: #4a5b57;\n    background-color: #ffffff;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    font-weight: bold;\n  transition: background-color 0.5s ease;\n\n  }\n  \n  .button:hover {\n    background-color: #4a5b57;\n    color: white;\n  }\n  \n\n  @media screen and (max-width:768px) {\n    .title {\n      font-size: 1.5rem;\n     \n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formContainer": `PatientForm_formContainer__ep1VC`,
	"title": `PatientForm_title__3Ulvq`,
	"form": `PatientForm_form__abZxr`,
	"label": `PatientForm_label__2kGRN`,
	"input": `PatientForm_input__n16AZ`,
	"button": `PatientForm_button__yGkV-`
};
export default ___CSS_LOADER_EXPORT___;
